// 与 /resources 页顶部绿条保持一致（.top-banner）
export const SiteTopBanner = () => (
  <div className='bg-primary px-4 py-2.5 text-center font-poppins text-sm font-medium tracking-[0.3px] text-white'>
    Free Shipping on All Orders · Lifetime Warranty · 30-Day Returns
  </div>
);

export default SiteTopBanner;
